import { DEALERS_API_URL } from 'constants/ApiConstants';
import type { MetaAction } from 'modules/global/generic.types';

import * as types from '../actionTypes';
import type {
  StepsRecords,
  UpdateStepAction,
  DeleteStepAction,
  CreateStepAction,
  CreateStepPayload,
  DeleteStepPayload,
  UpdateStepPayload,
  ReorderStepsAction,
  ReorderStepsPayload,
  PatchStepsModeAction,
  PatchStepsModePayload,
  CreateStepSuccessAction,
  DeleteStepSuccessAction,
  FetchStepsFailureAction,
  FetchStepsSuccessAction,
  UpdateStepSuccessAction,
  CreateStepSuccessPayload,
  DeleteStepSuccessPayload,
  UpdateStepSuccessPayload,
  ReorderStepsSuccessAction,
  ReorderStepsSuccessPayload,
  PatchStepsModeSuccessAction,
  PatchStepsModeSuccessPayload,
} from '../types/actions';

export const fetchStepsSuccess = (dealerId: string, stepsByMode: StepsRecords, meta: MetaAction = {}): FetchStepsSuccessAction => ({
  type: types.FETCH_STEPS_SUCCESS,
  payload: {
    dealerId,
    steps: stepsByMode,
  },
  meta,
});

export const fetchStepsFailure = (message: string, meta: MetaAction = {}): FetchStepsFailureAction => ({
  type: types.FETCH_STEPS_FAILURE,
  payload: message,
  error: true,
  meta,
});

export const patchStepsMode = ({ enabled, ...data }: PatchStepsModePayload, meta: MetaAction = {}): PatchStepsModeAction => ({
  type: types.PATCH_STEPS_MODE_REQUEST,
  payload: {
    ...data,
    request: {
      method: 'PATCH',
      url: `${DEALERS_API_URL}/${data.dealerId}/config/steps/${data.mode}`,
      data: { enabled },
    },
  },
  meta,
});

export const patchStepsModeSuccess = (payload: PatchStepsModeSuccessPayload, meta: MetaAction = {}): PatchStepsModeSuccessAction => ({
  type: types.PATCH_STEPS_MODE_SUCCESS,
  payload,
  meta,
});

export const reorderSteps = ({ steps, ...data }: ReorderStepsPayload, meta: MetaAction = {}): ReorderStepsAction => ({
  type: types.REORDER_STEPS_REQUEST,
  payload: {
    ...data,
    request: {
      method: 'PUT',
      url: `${DEALERS_API_URL}/${data.dealerId}/config/steps/${data.mode}/reorder`,
      data: { ids: steps.map(step => step.id) },
    },
  },
  meta,
});

export const reorderStepsSuccess = (payload: ReorderStepsSuccessPayload, meta: MetaAction = {}): ReorderStepsSuccessAction => ({
  type: types.REORDER_STEPS_SUCCESS,
  payload,
  meta,
});

export const createStep = ({ step, ...data }: CreateStepPayload, meta: MetaAction = {}): CreateStepAction => ({
  type: types.CREATE_STEP_REQUEST,
  payload: {
    ...data,
    request: {
      method: 'POST',
      url: `${DEALERS_API_URL}/${data.dealerId}/config/steps/${data.mode}/step`,
      data: step,
    },
  },
  meta,
});

export const createStepSuccess = (payload: CreateStepSuccessPayload, meta: MetaAction = {}): CreateStepSuccessAction => ({
  type: types.CREATE_STEP_SUCCESS,
  payload,
  meta,
});

export const updateStep = ({ step, ...data }: UpdateStepPayload, meta: MetaAction = {}): UpdateStepAction => ({
  type: types.UPDATE_STEP_REQUEST,
  payload: {
    ...data,
    request: {
      method: 'PUT',
      url: `${DEALERS_API_URL}/${data.dealerId}/config/steps/${data.mode}/step/${step.id}`,
      data: step,
    },
  },
  meta,
});

export const updateStepSuccess = (payload: UpdateStepSuccessPayload, meta: MetaAction = {}): UpdateStepSuccessAction => ({
  type: types.UPDATE_STEP_SUCCESS,
  payload,
  meta,
});

export const deleteStep = (data: DeleteStepPayload, meta: MetaAction = {}): DeleteStepAction => {
  const { dealerId, mode, stepId } = data;

  return {
    type: types.DELETE_STEP_REQUEST,
    payload: {
      data,
      request: {
        method: 'DELETE',
        url: `${DEALERS_API_URL}/${dealerId}/config/steps/${mode}/step/${stepId}`,
      },
    },
    meta,
  };
};

export const deleteStepSuccess = (payload: DeleteStepSuccessPayload, meta: MetaAction = {}): DeleteStepSuccessAction => ({
  type: types.DELETE_STEP_SUCCESS,
  payload,
  meta,
});
